import React from "react";

import { Divider, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import IconBackground from "@rui/IconBackground";
import Stack, { Row } from "@rui/Stack";

export interface MeetingPolicyModuleProps {
  title: string;
  highest: string;
  lowest: string;
  children?: React.ReactNode;
}

const Module = styled(Stack)(({ theme }) => ({
  height: "400px",
  width: "100%",
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: "8px",
  padding: theme.spacing(2),
  backgroundColor: "#FFF",
  [theme.breakpoints.up("lg")]: {
    height: "320px",
    // 12px = 1/2 the space between modules
    width: "calc(50% - 12px)",
  },
}));

const ContentContainer = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "250px",
  flexGrow: 1,
  paddingTop: theme.spacing(1.5),
}));

const Stat = ({
  type,
  value,
}: {
  type: "highest" | "lowest";
  value: string;
}) => {
  const emoji = type === "highest" ? "🏆" : "🙈";
  return (
    <Row alignItems="center" spacing={1}>
      <IconBackground
        height={24}
        sx={{ bgcolor: "shades.ghost.500" }}
        borderRadius="4px"
      >
        <Typography variant="bodySecondaryReg">{emoji}</Typography>
      </IconBackground>
      <Typography variant="bodySecondaryReg">{value}</Typography>
    </Row>
  );
};

const MeetingPolicyModule = ({
  title,
  highest,
  lowest,
  children,
}: MeetingPolicyModuleProps) => {
  return (
    <Module>
      <Row variant="apart" sx={{ px: 1, pb: 1 }}>
        <Typography variant="h2" fontWeight={500}>
          {title}
        </Typography>
        <Row alignItems="center" spacing={2}>
          <Stat type="highest" value={highest} />
          <Stat type="lowest" value={highest === lowest ? "-" : lowest} />
        </Row>
      </Row>
      <Divider sx={{ width: "100%" }} />
      <ContentContainer>{children}</ContentContainer>
    </Module>
  );
};

export default MeetingPolicyModule;
